import { Grid } from '@chakra-ui/react';

export const titleText = {
  fontSize: { base: '6vw', md: '2vw' },
  fontWeight: '700',
  padding: { base: '0 2vw', md: '0 0' },
};
export const titleSubText = {
  fontSize: { base: '4vw', md: '1vw' },
  fontWeight: '400',
  padding: { base: '0 2vw 5vw', md: '0 0 1vw' },
};
export const outerContainer = {
  backgroundColor: { base: '', md: '#00000010' },
  borderRadius: '2vw',
  marginTop: { base: '1.5vw', md: '0vw' },
  id: 'stdSizes',
  padding: { base: '0', md: '2vw 2vw 2vw 2vw' },
  height: 'auto',
};
export const mainContainer = {
  columns: { base: 1, md: 4 },
  spacing: { base: '2vw', md: '0.5vw' },
};
export const innerContainer = {
  bgColor: 'white',
  borderRadius: { base: '4vw', md: '2vw' },
  padding: { base: '6vw 2vw 2vw', md: '1vw' },
  textAlign: 'center',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  //border: 'solid 3px blue',
};
export const innerContainerGrid = {
  bgColor: 'white',
  borderRadius: { base: '5vw', md: '2vw' },
  padding: { base: '5vw 5vw 5vw 3vw', md: '1vw' },
  textAlign: 'center',
  height: '100%',
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gridTemplateRows: 'auto auto auto auto',
  position: 'relative',
  border: { base: 'solid 1px #00000030', md: '' },
};
export const showTitle = {
  fontSize: { base: '4.4vw', md: '1.0vw' },
  lineHeight: { base: '4vw', md: '1.0vw' },
  fontWeight: 700,
  textTransform: 'uppercase',
  padding: { base: '0vw', md: '0.5vw 0' },
  width: '100%',
  gridColumn: '2 / 3', // Occupies column 1
  gridRow: '1 / 2',
  // border: 'solid 3px red',
  justifyContent: { base: 'left', md: 'center' },
};
export const showImgBox = {
  padding: { base: '0 2vw 0 0', md: '0 0 0 0' },
  width: '100%',
  gridColumn: '1 / 2', // Occupies column 1
  gridRow: '1 / 5',
  // border: 'solid 3px red',
};
export const showDesc = {
  display: 'flex',
  fontSize: { base: '3vw', md: '0.8vw' },
  lineHeight: { base: '4.2vw', md: '1vw' },
  letterSpacing: '-0.02vw',
  flexGrow: 1,
  justifyContent: { base: '', md: 'center' }, // for flex alignment
  alignItems: { base: '', md: 'center' }, // for flex alignment
  textAlign: { base: 'left', md: 'center' }, // for Grid alignment
  padding: { base: '3vw 0', md: '0.5vw 0' },
  gridColumn: '2 / 3', // Occupies column 1
  gridRow: '2 / 3',
  width: '100%',
  height: { base: 'auto', md: '' },
  //border: 'solid 1px red',
};
export const showPrice = {
  gridColumn: '1 / 4',
  gridRow: '1',
  fontSize: { base: '3vw', md: '0.7vw' },
  justifyContent: { base: 'start', md: 'center' },
  lineHeight: { base: '3vw', md: '1.0vw' },
  width: '100%',
  padding: { base: '0 0 1vw', md: '0 0 1vw' },
  gridColumn: '2 / 3', // Occupies column 1
  gridRow: '3 / 4',
  // border: 'solid 3px green',
};
export const priceGrid = {
  display: 'inline-grid',
  gridTemplateColumns: 'auto auto auto',
  gridTemplateRows: 'auto',
  // width: 'auto',
  margin: { base: '0 0 2vw', md: 'auto' },
  fontWeight: 600,
  // border: 'solid 3px blue',
};

export const showButton = {
  width: '100%',
  fontSize: { base: '4vw', md: '0.9vw' },
  lineHeight: { base: '4vw', md: '1vw' },
  gridColumn: '2 / 3', // Occupies column 1
  gridRow: '4 / 5',
};

export const priceOffer = {
  fontSize: { base: '5vw', md: '1.0vw' },
  fontWeight: 700,
  textTransform: 'uppercase',
  alignSelf: 'center',
  padding: { base: '3vw 0vw', md: '0 0 0.5vw' },
  width: '100%',
};

export const showImg = {
  width: { base: '100%', md: '80%' },
  height: '100%',
  objectFit: 'contain',
};

export const showDescLine = {
  width: '100%',
  fontSize: { base: '3vw', md: '0.8vw' },
  textAlign: { base: 'start', md: 'center' },
  lineHeight: { base: '5vw', md: '1.3vw' },
};

export const priceText = {
  gridColumn: '1 / 4',
  gridRow: '1',
  fontSize: { base: '2vw', md: '0.7vw' },
  alignSelf: { base: 'start', md: 'end' },
  //border: 'solid 3px red',
  lineHeight: { base: '5vw', md: '1.0vw' },
};
export const pricePound = {
  fontSize: { base: '3vw', md: '1.5vw' },
  fontWeight: 700,
  alignSelf: 'start',
  padding: { base: '0.6vw 0.5vw 0 0', md: '0 0.2vw 0 0' },
  lineHeight: { base: '2.5vw', md: '1.6vw' },
};
export const pricePounds = {
  lineHeight: { base: '5vw', md: '2vw' },
  fontWeight: 700,
  fontSize: { base: '5vw', md: '2vw' },
};
export const pricePence = {
  alignSelf: { base: 'start', md: 'end' },
  fontSize: { base: '5vw', md: '0.9vw' },
  fontWeight: { base: '700', md: '400' },
  lineHeight: { base: '5vw', md: '1vw' },
};

export const outerContainerText = {
  padding: { base: '4vw 3vw 3vw', md: '1vw 3vw' },
  fontSize: { base: '4vw', md: '1vw' },
  textAlign: 'center',
  //border: 'solid 3px Purple',
};

// ###### BUTTONS ######
export const buttonSelectGry = {
  width: '100%',
  borderRadius: { base: '6vw', md: '2.5vw' },
  bg: 'gray.700',
  color: 'white',
  alignSelf: 'end',
  fontSize: { base: '4vw', md: '1vw', lg: '0.8vw' },
  fontWeight: 600,
  padding: { base: '2vw 0', md: '1vw 0' },
  _hover: {
    cursor: 'pointer',
    bg: 'gray.500',
  },
};
export const buttonSelect = {
  width: '100%',
  borderRadius: { base: '6vw', md: '2.5vw' },
  bgColor: '#0cc6de',
  color: 'white',
  alignSelf: 'end',
  fontSize: { base: '4vw', md: '1vw', lg: '0.8vw' },
  fontWeight: 600,
  padding: { base: '4vw 0', md: '1vw 0' },
  border: 'solid 2px #0cc6de',
  _hover: {
    cursor: 'pointer', // Correct hover effect for the button
    bgColor: '#0cc6de80',
    border: 'solid 2px #0cc6de00',
  },
};
export const buttonSelected = {
  width: '100%',
  borderRadius: { base: '6vw', md: '2.5vw' },
  bgColor: '#ffffff',
  color: '#0cc6de',
  alignSelf: 'end',
  fontSize: { base: '4vw', md: '1vw', lg: '0.8vw' },
  fontWeight: 600,
  padding: { base: '4vw 0', md: '1vw 0' },
  border: 'solid 2px #0cc6de',
};
export const selectedButton = {
  background: 'white',
  position: 'absolute',
  top: { base: '3vw', md: '-6' },
  left: { base: '7vw', md: 'auto' },
  //zIndex: '10',
  border: 'solid 2px #0cc6de',
  color: '#0cc6de',
  borderRadius: { base: '6vw', md: '3vw' },
  padding: { base: '0vw 3vw', md: '1vw 2vw', lg: '0.5vw 1vw' },
  fontSize: { base: '3vw', md: '1.0vw', lg: '0.7vw' },
  lineHeight: { base: '7vw', md: '1vw' },
};
export const buttonNext = {
  width: { base: '100%', md: '25%' }, // Ensures button spans the available space
  borderRadius: { base: '6vw', md: '2.5vw' },
  bg: '#0cc6de',
  color: 'white',
  fontSize: { base: '4vw', md: '1vw' },
  fontWeight: '600',
  padding: { base: '6vw', md: '1vw 0' },
  _hover: {
    cursor: 'pointer',
    bg: '#0cc6de80',
  },
  marginLeft: { base: '2vw', md: 'auto' },
};
export const buttonPrevious = {
  width: '25%',
  borderRadius: { base: '6vw', md: '2.5vw' },
  bg: 'gray.700',
  color: 'white',
  fontSize: { base: '6vw', md: '1vw' },
  fontWeight: 600,
  padding: { base: '6vw 0', md: '1vw 0' },
  _hover: {
    cursor: 'pointer',
    bg: 'gray.500',
  },
};
export const buttonGrey = {
  borderRadius: { base: '6vw', md: '2.5vw' },
  bg: '#000000030',
  color: 'white',
  fontSize: { base: '4vw', md: '1vw' },
  fontWeight: 600,
  padding: { base: '6vw 0', md: '1vw 0' },
  width: '100%',
};
export const infoButton = {
  background: 'white',
  width: '100%',
  color: '#DA217E',
  fontWeight: '400',
  borderRadius: { base: '6vw', md: '2vw' },
  padding: { base: '6vw 3vw', md: '1vw 2vw', lg: '0.5vw 1vw' },
  fontSize: { base: '4vw', md: '1.2vw', lg: '0.9vw' },
  sx: {
    whiteSpace: 'normal', // Allows text to wrap
    wordWrap: 'break-word', // Breaks long words if necessary
    textAlign: 'center', // Ensures the text remains centered
  },
};
export const previousIconBox = {
  position: { base: 'absolute', md: 'absolute' },
  left: { base: '', md: '1vw' }, // Adjusts the distance of the icon from the button's right edge
  display: 'flex',
  alignItems: 'center',
};
export const nextIconBox = {
  position: { base: 'absolute', md: 'absolute' },
  right: { base: '4vw', md: '1vw' }, // Adjusts the distance of the icon from the button's right edge
  display: 'flex',
  alignItems: 'center',
};
export const warning = {
  background: 'white',
  width: '100%',
  color: '#DA217E',
  borderRadius: { base: '6vw', md: '2vw' },
  padding: { base: '6vw 3vw', md: '1vw 2vw', lg: '0.5vw 1vw' },
  fontSize: { base: '4vw', md: '1.2vw', lg: '0.9vw' },
  fontWeight: '400',
  margin: '1vw 0 0',
  sx: {
    whiteSpace: 'normal', // Allows text to wrap
    wordWrap: 'break-word', // Breaks long words if necessary
    textAlign: 'center', // Ensures the text remains centered
  },
};
export const inputSection = {
  background: 'white',
  borderRadius: { base: '4vw', md: '2vw' },
  padding: { base: '4vw 3vw 3vw 3vw', md: '0.75vw 2vw 0.5vw' },
  templateColumns: { base: '1fr 4fr', md: '0.5fr 6fr 1fr' },
  templateRows: { base: '1fr 0.5fr', md: '1fr' },
  alignItems: 'center',
  marginBottom: { base: '3vw', md: '0.5vw' },
};
